import { AxiosInstance } from "axios"
import { ChunkedArrayResponse } from "../../../oneportal/units/types/ChunkedArrayResponse"
import { ChunkedLookupResponse } from "../../../oneportal/units/types/ChunkedLookupResponse"

export const getLookupReceiveType = async (
  api: AxiosInstance
): Promise<ChunkedArrayResponse<ChunkedLookupResponse> | undefined> => {
  try {
    const res = await api.get<ChunkedArrayResponse<ChunkedLookupResponse>>("/api/admin/ReceiveType/GetLookup")
    return res.data
  } catch (err) {}
}
